import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAhjFeeScheduleVariableMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Ahj_Fee_Schedule_Variables_Set_Input;
}>;


export type UpdateAhjFeeScheduleVariableMutation = { __typename?: 'mutation_root', update_ahj_fee_schedule_variables_by_pk?: { __typename?: 'ahj_fee_schedule_variables', id: any } | null };


export const UpdateAhjFeeScheduleVariableDocument = gql`
    mutation updateAhjFeeScheduleVariable($id: uuid!, $set: ahj_fee_schedule_variables_set_input!) {
  update_ahj_fee_schedule_variables_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdateAhjFeeScheduleVariableMutationFn = Apollo.MutationFunction<UpdateAhjFeeScheduleVariableMutation, UpdateAhjFeeScheduleVariableMutationVariables>;

/**
 * __useUpdateAhjFeeScheduleVariableMutation__
 *
 * To run a mutation, you first call `useUpdateAhjFeeScheduleVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAhjFeeScheduleVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAhjFeeScheduleVariableMutation, { data, loading, error }] = useUpdateAhjFeeScheduleVariableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateAhjFeeScheduleVariableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAhjFeeScheduleVariableMutation, UpdateAhjFeeScheduleVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAhjFeeScheduleVariableMutation, UpdateAhjFeeScheduleVariableMutationVariables>(UpdateAhjFeeScheduleVariableDocument, options);
      }
export type UpdateAhjFeeScheduleVariableMutationHookResult = ReturnType<typeof useUpdateAhjFeeScheduleVariableMutation>;
export type UpdateAhjFeeScheduleVariableMutationResult = Apollo.MutationResult<UpdateAhjFeeScheduleVariableMutation>;
export type UpdateAhjFeeScheduleVariableMutationOptions = Apollo.BaseMutationOptions<UpdateAhjFeeScheduleVariableMutation, UpdateAhjFeeScheduleVariableMutationVariables>;